import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Auto, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'
import * as API from 'modules/app/API'

class AutoDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				presetValue: 1,
				presetLabel: 'Administrator'
			}
		};
	}

	usersLoader = () => {
		return {
			url: API.Security.url('/lookup/lookupUser'),
			params: {}
		}
	}

	rolesLoader = () => {
		return {
			url: API.Security.url('/lookup/lookupRole'),
			params: {}
		}
	}

	roleUsersLoader = () => {
		return {
			url: API.Security.url('/lookup/lookupRoleUser'),
			params: {
				roleId: this.state.form.roleId
			}
		}
	}

	onChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="Auto">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
							<Label htmlFor="default">Default</Label>
							<Auto name="defaultId" label="defaultName" loader={this.rolesLoader} />
						</Col>
						<Col md={4}>
							<Label htmlFor="placeholder">Placeholder</Label>
							<Auto name="placeholderId" label="placeholderName" placeholder="ALL" loader={this.rolesLoader} />
						</Col>
						<Col md={4}>
							<Label htmlFor="disabled">Disabled</Label>
							<Auto name="disabledId" label="disabledName" disabled={true} loader={this.rolesLoader} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="preset">Preset</Label>
							<Auto name="presetValue" label="presetLabel" loader={this.rolesLoader} />
						</Col>
						<Col md={4}>
							<Label htmlFor="validationError" required>Required</Label>
							<Auto name="validationErrorId" label="validationErrorName" loader={this.rolesLoader} required />
						</Col>
						<Col md={4}>
							<Label htmlFor="Clearable">Clearable</Label>
							<Auto name="clearableId" label="clearableName" clearable={true} loader={this.rolesLoader} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label>Role (Parent)</Label>
							<Auto name="roleId" label="roleName" loader={this.rolesLoader} />
						</Col>
						<Col md={4}>
							<Label>User (Child)</Label>
							<Auto name="userId" label="userName" loader={this.roleUsersLoader} />
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default AutoDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DropDowns/AutoDemo.js